import { render, staticRenderFns } from "./ProjectBasis.vue?vue&type=template&id=66b4be50&"
import script from "./ProjectBasis.vue?vue&type=script&lang=js&"
export * from "./ProjectBasis.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBasis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectBasis.vue"
export default component.exports